export const homeObjOne = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: '',
    headline: "Servicios en línea",
    description: 'Accede al portal web para monitorear y consultar los datos de tu contrato. ',
    buttonLabel: 'Acceder',
    btnLink: "/login",
    imgStart: '',
    img: 'images/home/laptop1.png',
    imgAnimation: "animation_slowbreath",
    alt: 'hlaptop'
}
export const homeSolicitudCredito = {
    id: "heroSolicitudCredito",
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: '',
    headline: "SOLICITUD",
    description: 'Descargar formato de solictud de crédito',
    buttonLabel: false,
    imgStart: 'start',
    img: false,
    alt: 'hlaptop',
    moreButtons: [
        {label:"Persona Moral", link:false, href:`${process.env.PUBLIC_URL}/docs/credito_persona_moral_total.pdf`, id:"btn_PersonaMoral"},
        {label:"Persona Física", link:false, href:`${process.env.PUBLIC_URL}/docs/credito_persona_fisica_total.pdf`, id:"btn_PersonaFisica"},
        //{label:"Documentos Adicionales", link:false, href:false, id:"modal_Solicitud"},
        {label:"Documentos Adicionales", link:false, href:`${process.env.PUBLIC_URL}/docs/credito_persona_moral_total_Buro.pdf`, id:"modal_Solicitud"},

    ],
    buttonColor: "orange",
    textFloat:"center"
}
export const homeCotizador = {
    id: "heroCotizadorWeb",
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: '',
    headline: "Calcula tu crédito",
    description: '¡Cotizar en nuestra plataforma es fácil y rápido! Haz click aquí y cotiza.',
    buttonLabel: "Calcula aquí",
    btnLink: "/cotizador",
    buttonId:"home_btnCotizador",
    imgObject: true,
    imgStart: 'start',
    // img: 'images/home/cotizador.svg',
    img: `<svg
    width="210mm"
    height="139mm"
    viewBox="0 0 210 139"
    version="1.1"
    id="svg5"
    inkscape:version="1.1.1 (3bf5ae0d25, 2021-09-20)"
    sodipodi:docname="cotizador.svg"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg">
   <sodipodi:namedview
      id="namedview7"
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1.0"
      inkscape:pageshadow="2"
      inkscape:pageopacity="0.0"
      inkscape:pagecheckerboard="0"
      inkscape:document-units="mm"
      showgrid="false"
      inkscape:zoom="0.45611672"
      inkscape:cx="147.98844"
      inkscape:cy="656.63017"
      inkscape:window-width="1920"
      inkscape:window-height="1017"
      inkscape:window-x="-8"
      inkscape:window-y="-8"
      inkscape:window-maximized="1"
      inkscape:current-layer="layer4"
      units="mm"
      height="296mm" />
   <defs
      id="defs2" />
   <g
      inkscape:groupmode="layer"
      id="layer3"
      inkscape:label="Capa 3"
      style="display:inline">
     <g
        id="g3611"
        transform="matrix(0.40922901,0,0,0.39408316,8.9153899,16.03252)"
        style="display:inline">
       <circle
          cx="12.944"
          cy="12.944"
          r="12.944"
          fill="#d2f1ff"
          id="circle16"
          style="display:inline;fill:#ffbb00;fill-opacity:1"
          transform="matrix(1.4275645,0.72406809,-0.69626957,1.48456,252.15342,50.685141)" />
       <text
          xml:space="preserve"
          style="font-style:normal;font-weight:normal;font-size:21.2806px;line-height:1.25;font-family:sans-serif;white-space:pre;inline-size:19.3518;display:inline;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.532;stroke-miterlimit:4;stroke-dasharray:none"
          x="-73.470581"
          y="-38.002861"
          id="text4993-7"
          transform="matrix(-1.3239293,-0.32304883,0.36417284,-1.2898123,189.44549,0.83383374)"><tspan
            x="-73.470581"
            y="-38.002861"
            id="tspan9090"><tspan
              style="fill:#ffffff"
              id="tspan9088">$</tspan></tspan></text>
     </g>
     <g
        id="g3611-9"
        transform="matrix(0.43892919,-0.24262488,0.21826714,0.45246434,-101.26934,68.829668)"
        style="display:inline">
       <circle
          cx="12.944"
          cy="12.944"
          r="12.944"
          fill="#d2f1ff"
          id="circle16-6"
          style="display:inline;fill:#ffbf02;fill-opacity:1"
          transform="matrix(1.4275645,0.72406809,-0.69626957,1.48456,252.15342,50.685141)" />
       <text
          xml:space="preserve"
          style="font-style:normal;font-weight:normal;font-size:21.2806px;line-height:1.25;font-family:sans-serif;white-space:pre;inline-size:19.3518;display:inline;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.532;stroke-miterlimit:4;stroke-dasharray:none"
          x="-73.470581"
          y="-38.002861"
          id="text4993-7-8"
          transform="matrix(-1.3239293,-0.32304883,0.36417284,-1.2898123,189.44549,0.83383374)"><tspan
            x="-73.470581"
            y="-38.002861"
            id="tspan9094"><tspan
              style="fill:#ffffff"
              id="tspan9092">$</tspan></tspan></text>
     </g>
   </g>
   <g
      inkscape:label="Capa 1"
      inkscape:groupmode="layer"
      id="layer1"
      style="display:inline">
     <g
        transform="matrix(0.58697496,-0.07934375,0.08249389,0.56456053,34.935741,24.613722)"
        id="g72"
        style="display:inline">
       <path
          fill="#0d97dc"
          d="M 9.642,1.639 85.162,0.9 a 9,9 0 0 1 9.088,8.911 v 0.088 105.979 a 9,9 0 0 1 -8.824,8.998 l -75.63,1.479 A 9,9 0 0 1 0.622,117.533 L 0.62,117.348 0.73,10.63 A 9,9 0 0 1 9.642,1.64 Z"
          id="path32" />
       <rect
          width="90.608002"
          height="120.195"
          x="4.6230001"
          y="0.92500001"
          rx="9"
          class="I"
          id="rect34"
          style="fill:#00b7f9;fill-opacity:1" />
       <rect
          width="72.116081"
          height="23.114"
          x="13.869"
          y="10.17"
          rx="3"
          class="B"
          id="rect36"
          style="fill:#f5fcfc;fill-opacity:1" />
       <g
          fill="#f7f7f7"
          id="g68">
         <rect
            width="11.095"
            height="11.095"
            x="16.642"
            y="42.529999"
            rx="1"
            class="G"
            id="rect38" />
         <rect
            width="11.095"
            height="11.095"
            x="35.133999"
            y="42.529999"
            rx="1"
            class="G"
            id="rect40" />
         <rect
            width="11.095"
            height="11.095"
            x="53.625"
            y="42.529999"
            rx="1"
            class="G"
            id="rect42" />
         <rect
            width="11.095"
            height="11.095"
            x="72.116997"
            y="42.529999"
            rx="1"
            class="G"
            id="rect44" />
         <rect
            width="11.095"
            height="11.095"
            x="16.642"
            y="61.021999"
            rx="1"
            class="C"
            id="rect46" />
         <rect
            width="11.095"
            height="11.095"
            x="35.133999"
            y="61.021999"
            rx="1"
            class="C"
            id="rect48" />
         <rect
            width="11.095"
            height="11.095"
            x="53.625"
            y="61.021999"
            rx="1"
            class="C"
            id="rect50" />
         <rect
            width="11.095"
            height="11.095"
            x="72.116997"
            y="61.021999"
            rx="1"
            class="C"
            id="rect52" />
         <rect
            width="11.095"
            height="11.095"
            x="16.642"
            y="79.513"
            rx="1"
            class="C"
            id="rect54" />
         <rect
            width="11.095"
            height="11.095"
            x="35.133999"
            y="79.513"
            rx="1"
            class="C"
            id="rect56" />
         <rect
            width="11.095"
            height="11.095"
            x="53.625"
            y="79.513"
            rx="1"
            class="C"
            id="rect58" />
         <rect
            width="11.095"
            height="29.586"
            x="72.116997"
            y="79.513"
            opacity="0.795"
            rx="1"
            id="rect60" />
         <rect
            width="11.095"
            height="11.095"
            x="16.642"
            y="98.004997"
            rx="1"
            class="J"
            id="rect62" />
         <rect
            width="11.095"
            height="11.095"
            x="35.133999"
            y="98.004997"
            rx="1"
            class="J"
            id="rect64" />
         <rect
            width="11.095"
            height="11.095"
            x="53.625"
            y="98.004997"
            rx="1"
            class="J"
            id="rect66" />
       </g>
       <path
          fill="#6b676f"
          d="m 24.18,28.068 c 1.083,0 1.982,-0.345 2.695,-1.035 0.713,-0.69 1.07,-1.585 1.07,-2.684 0,-1.359 -0.594,-2.307 -1.781,-2.844 0.484,-0.245 0.854,-0.589 1.109,-1.031 0.255,-0.442 0.383,-0.948 0.383,-1.516 0,-0.901 -0.302,-1.651 -0.906,-2.25 -0.604,-0.599 -1.406,-0.898 -2.406,-0.898 -0.526,0 -1.003,0.09 -1.43,0.27 -0.427,0.18 -0.78,0.427 -1.059,0.742 -0.279,0.315 -0.496,0.681 -0.652,1.098 a 4.05,4.05 0 0 0 -0.25,1.344 h 1.609 c 0.01,-0.568 0.165,-1.043 0.465,-1.426 0.3,-0.383 0.728,-0.574 1.285,-0.574 0.516,0 0.932,0.163 1.25,0.488 0.318,0.325 0.477,0.738 0.477,1.238 0,0.505 -0.161,0.926 -0.484,1.262 -0.323,0.336 -0.747,0.504 -1.273,0.504 v 0 H 23.72 v 1.5 c 0.802,0 1.423,0.184 1.863,0.551 0.44,0.367 0.66,0.91 0.66,1.629 0,0.375 -0.06,0.704 -0.18,0.988 -0.12,0.284 -0.28,0.507 -0.48,0.668 a 2.13,2.13 0 0 1 -0.66,0.363 c -0.24,0.081 -0.492,0.121 -0.758,0.121 -0.604,0 -1.092,-0.19 -1.465,-0.57 -0.373,-0.38 -0.577,-0.904 -0.613,-1.57 v 0 h -1.633 c 0.042,1.057 0.402,1.927 1.082,2.609 0.68,0.682 1.561,1.023 2.645,1.023 z m 12.523,-0.211 v -1.539 h -5.07 l 3.07,-3.07 c 0.682,-0.682 1.206,-1.348 1.57,-1.996 a 4.21,4.21 0 0 0 0.547,-2.098 c 0,-1.031 -0.34,-1.846 -1.02,-2.445 -0.68,-0.599 -1.551,-0.898 -2.613,-0.898 -1.047,0 -1.889,0.298 -2.527,0.895 -0.638,0.597 -1.017,1.444 -1.137,2.543 h 1.586 c 0.104,-0.661 0.333,-1.168 0.688,-1.52 0.355,-0.352 0.812,-0.527 1.375,-0.527 0.604,0 1.089,0.191 1.453,0.574 0.364,0.383 0.547,0.879 0.547,1.488 0,0.542 -0.171,1.077 -0.512,1.605 -0.341,0.528 -0.918,1.194 -1.73,1.996 v 0 l -3.453,3.438 v 1.555 h 7.227 z m 5.914,0.211 c 1.151,0 2.113,-0.392 2.887,-1.176 0.774,-0.784 1.16,-1.764 1.16,-2.941 0,-1.135 -0.361,-2.086 -1.082,-2.852 -0.721,-0.766 -1.639,-1.148 -2.754,-1.148 -0.641,0 -1.211,0.133 -1.711,0.398 v 0 l 0.508,-2.828 h 4.164 l 0.078,-1.508 h -5.555 l -0.922,5.367 1.18,0.859 c 0.255,-0.286 0.566,-0.499 0.934,-0.637 0.368,-0.138 0.738,-0.207 1.113,-0.207 0.729,0 1.318,0.238 1.766,0.715 0.448,0.477 0.672,1.09 0.672,1.84 0,0.76 -0.228,1.388 -0.684,1.883 -0.456,0.495 -1.051,0.742 -1.785,0.742 A 2.42,2.42 0 0 1 41.613,26.384 2.03,2.03 0 0 1 40.89,25.876 c -0.187,-0.211 -0.339,-0.44 -0.453,-0.687 a 2.89,2.89 0 0 1 -0.234,-0.77 v 0 H 38.57 c 0.13,1.052 0.57,1.923 1.32,2.613 0.75,0.69 1.659,1.035 2.727,1.035 z"
          opacity="0.39"
          class="F"
          id="path70" />
     </g>
   </g>
   <g
      inkscape:groupmode="layer"
      id="layer2"
      inkscape:label="Capa 2"
      style="display:inline">
     <path
        style="fill:#09406a;fill-opacity:1;stroke-width:0.387569"
        d=""
        id="path17849"
        transform="scale(0.26458333)" />
     <path
        style="fill:#09406a;fill-opacity:1;stroke-width:0.548105"
        d=""
        id="path18161"
        transform="scale(0.26458333)" />
     <path
        style="fill:#3076a9;fill-opacity:1;stroke-width:0.274053"
        d=""
        id="path20035"
        transform="scale(0.26458333)" />
     <path
        style="fill:#3076a9;fill-opacity:1;stroke-width:0.274053"
        d=""
        id="path20269"
        transform="scale(0.26458333)" />
     <g
        id="g4144"
        transform="matrix(-0.55369311,0,0,0.65118924,187.57614,62.231441)"
        style="display:inline">
       <g
          id="g7588"
          transform="matrix(1.1526227,0,0,1.0786123,-21.143079,6.9288049)">
         <path
            d="m 111.368,96.151 h 9.978 c 8.471,0 15.34,-10.555 15.34,-23.577 C 136.686,59.552 129.817,49 121.346,49 h -9.978 c -8.473,0 -15.342,10.555 -15.342,23.574 0,13.019 6.869,23.577 15.342,23.577 z m 132.001,0 h 9.978 c 8.471,0 15.34,-10.555 15.34,-23.577 0,-13.022 -6.87,-23.574 -15.34,-23.574 h -9.978 c -8.473,0 -15.34,10.555 -15.34,23.574 0,13.019 6.867,23.577 15.34,23.577 z M 12.003,82.283 h 41.55 V 38.83 h -41.55 z m 132.035,5.547 h 41.55 V 44.377 h -41.55 z"
            fill="#121212"
            id="path76" />
         <path
            d="m 163.992,96.151 h 9.966 c 8.461,0 15.323,-10.555 15.323,-23.577 C 189.281,59.552 182.419,49 173.958,49 h -9.966 c -9.218,0 -9.519,47.151 0,47.151"
            class="E"
            id="path78" />
         <path
            d="m 163.891,96.151 c 8.39,0 15.234,-10.59 15.234,-23.577 0,-12.987 -6.844,-23.574 -15.234,-23.574 -8.39,0 -15.236,10.59 -15.236,23.574 0,12.984 6.845,23.577 15.236,23.577"
            class="D"
            id="path80" />
         <path
            d="m 163.428,89.679 c 6.102,0 11.08,-7.683 11.08,-17.104 0,-9.421 -4.977,-17.104 -11.08,-17.104 -6.103,0 -11.08,7.685 -11.08,17.104 0,9.419 4.977,17.104 11.08,17.104"
            class="B"
            id="path82"
            style="fill:#ececec" />
         <path
            fill="#5c5f5f"
            d="m 163.891,87.83 c 5.34,0 9.694,-6.646 9.694,-14.794 0,-8.148 -4.354,-14.791 -9.694,-14.791 -5.34,0 -9.696,6.644 -9.696,14.791 0,8.147 4.354,14.794 9.696,14.794"
            id="path84" />
         <path
            d="m 165.736,86.906 c 4.474,-1.316 7.848,-7.231 7.848,-14.331 0,-7.1 -3.374,-13.014 -7.848,-14.329 -4.474,1.316 -7.848,7.231 -7.848,14.329 0,7.098 3.374,13.016 7.848,14.331"
            class="D"
            id="path86" />
         <path
            fill="#282929"
            d="m 165.623,58.328 v 4.928 l -2.12,1.569 -2.513,-3.072 -1.529,0.002 -0.568,4.024 2.513,3.075 -0.523,3.527 -3.132,1.098 -0.786,5.017 h 1.531 l 3.132,-1.096 1.473,2.828 0.1,6.678 1.531,-0.002 1.394,-4.44 h 2.359 l -0.098,3.193 c 1.358,-1.07 2.528,-2.622 3.412,-4.512 l -0.288,-0.917 1.471,-2.828 0.07,0.047 c 0.344,-1.516 0.532,-3.142 0.532,-4.839 l -0.053,-1.554 -0.325,-2.2 0.051,-0.064 c -0.342,-1.947 -0.937,-3.733 -1.729,-5.27 l -0.418,1.306 -2.12,-1.569 v -3.181 c -0.92,-0.86 -1.943,-1.486 -3.032,-1.83 l -0.335,0.083"
            id="path88" />
         <path
            d="m 163.998,58.463 v 4.905 l -2.144,1.562 -2.537,-3.058 c -0.852,1.135 -1.573,2.49 -2.118,4.007 l 2.539,3.06 -0.529,3.51 -3.167,1.093 c 0.056,1.765 0.319,3.447 0.753,4.994 l 3.167,-1.091 1.486,2.815 -1.409,4.419 c 0.912,0.995 1.944,1.756 3.057,2.225 l 1.409,-4.419 h 2.384 l 1.096,3.436 c 1.055,-0.738 2.006,-1.754 2.815,-2.988 l -0.854,-2.674 1.489,-2.815 1.501,0.516 c 0.401,-1.564 0.63,-3.259 0.649,-5.03 l -1.398,-0.482 -0.529,-3.51 1.277,-1.541 c -0.419,-1.634 -1.027,-3.124 -1.784,-4.409 l -1.612,1.94 -2.142,-1.562 V 59.05 a 7.15,7.15 0 0 0 -2.024,-0.807 c -0.468,0.023 -0.927,0.097 -1.376,0.218"
            class="B"
            id="path90"
            style="fill:#e6e6e6" />
         <path
            fill="#727675"
            d="m 165.736,69.34 c -1.274,0 -2.308,1.656 -2.308,3.699 0,2.043 1.034,3.697 2.308,3.697 1.274,0 2.308,-1.656 2.308,-3.697 0,-2.041 -1.034,-3.699 -2.308,-3.699"
            id="path92" />
         <path
            d="m 31.956,96.151 h 9.967 c 8.461,0 15.323,-10.555 15.323,-23.577 C 57.246,59.552 50.384,49 41.923,49 h -9.967 c -9.218,0 -9.518,47.151 0,47.151"
            class="E"
            id="path94" />
         <path
            d="m 31.856,96.151 c 8.391,0 15.234,-10.59 15.234,-23.577 C 47.09,59.587 40.246,49 31.856,49 23.466,49 16.62,59.59 16.62,72.574 c 0,12.984 6.845,23.577 15.236,23.577"
            class="D"
            id="path96" />
         <path
            d="m 31.393,89.679 c 6.103,0 11.08,-7.683 11.08,-17.104 0,-9.421 -4.977,-17.104 -11.08,-17.104 -6.103,0 -11.08,7.685 -11.08,17.104 0,9.419 4.977,17.104 11.08,17.104"
            class="B"
            id="path98"
            style="fill:#f2f2f2" />
         <path
            fill="#5c5f5f"
            d="m 31.855,87.83 c 5.339,0 9.695,-6.646 9.695,-14.794 0,-8.148 -4.356,-14.791 -9.695,-14.791 -5.339,0 -9.695,6.644 -9.695,14.791 0,8.147 4.356,14.794 9.695,14.794"
            id="path100" />
         <path
            d="m 33.7,86.906 c 4.474,-1.316 7.849,-7.231 7.849,-14.331 0,-7.1 -3.375,-13.014 -7.849,-14.33 -4.471,1.316 -7.847,7.231 -7.847,14.329 0,7.098 3.376,13.016 7.847,14.332"
            class="D"
            id="path102" />
         <path
            fill="#282929"
            d="m 25.726,72.299 3.153,1.286 0.445,3.576 -2.623,2.947 0.343,4.18 h 1.682 l 2.626,-2.949 2.118,1.701 0.454,4.79 c 1.033,-0.345 2.003,-0.937 2.884,-1.738 l 0.069,-2.855 2.198,-1.46 0.252,1.027 c 1.389,-2.555 2.224,-5.834 2.224,-9.41 a 21.89,21.89 0 0 0 -0.488,-4.635 l -1.2,-2.474 0.232,-0.672 C 39.26,63.565 38.103,61.851 36.734,60.631 l 0.115,3.232 -2.396,-0.139 -1.306,-4.552 -1.68,-0.002 -0.141,6.632 -1.56,2.756 -3.153,-1.284 -1.682,-0.002 0.796,5.027"
            id="path104" />
         <path
            d="m 24.006,71.224 3.16,1.272 0.448,3.534 -2.631,2.916 c 0.507,1.54 1.192,2.941 2.029,4.132 l 2.631,-2.916 2.125,1.682 -0.122,4.907 0.546,0.154 c 1.009,-0.057 1.981,-0.345 2.888,-0.832 l 0.1,-4.035 2.205,-1.443 1.435,1.856 c 0.798,-1.24 1.451,-2.694 1.916,-4.295 l -1.122,-1.452 0.622,-3.481 1.305,-0.372 0.009,-0.544 c 0,-1.587 -0.17,-3.113 -0.481,-4.545 l -1.47,0.419 -1.427,-2.905 0.933,-2.647 C 38.335,61.323 37.411,60.225 36.378,59.4 l -1.227,3.483 -2.401,-0.138 -1.307,-4.501 c -1.12,0.404 -2.181,1.105 -3.134,2.057 l 1.307,4.498 -1.564,2.725 -3.16,-1.272 a 20.2,20.2 0 0 0 -0.589,2.427 c -0.15,0.848 -0.25,1.697 -0.298,2.543"
            class="B"
            id="path106"
            style="fill:#ececec" />
         <path
            fill="#727675"
            d="m 31.472,72.08 c -0.33,1.974 0.402,4.001 1.632,4.529 1.23,0.528 2.496,-0.641 2.826,-2.615 0.33,-1.974 -0.4,-3.999 -1.632,-4.527 -1.232,-0.528 -2.496,0.641 -2.826,2.613"
            id="path108" />
         <path
            d="m 219.478,25.724 c 27.974,0.174 54.607,8.661 61.614,14.537 0.81,0.626 1.22,1.539 1.246,2.602 l 0.073,2.776 0.088,7.029 2.105,1.389 c 1.089,0.77 1.894,1.794 2.438,3.061 l 1.531,3.782 c 0.451,1.207 0.537,2.416 0.294,3.623 l -2.678,6.618 -2.085,9.355 1.345,2.182 1.55,2.202 a 1.8,1.8 0 0 1 0.404,1.134 c 0,0.999 -0.82,1.816 -1.819,1.816 H 194.033 L 182.113,48.122 138.689,45.129 71.096,2.076 c 17.798,-2.437 46.379,-1.916 63.919,-2.06 9.235,-0.077 23.287,0.058 34.277,1.771 14.299,3.044 30.49,11.07 50.187,23.937"
            class="H"
            id="path110"
            style="fill:#0084ce;fill-opacity:1" />
         <g
            fill="#186fd6"
            id="g116">
           <path
              d="m 288.077,64.237 -0.807,4.281 c -0.245,0.846 -0.702,1.647 -1.854,2.297 l -2.072,9.299 c 0.612,0.309 1.534,0.88 1.4,1.828 l -0.064,0.341 h -89.859 l 0.442,-19.838 7.234,-5.125 c 0.664,1.076 4.266,4.605 9.208,5.024 l 22.3,1.892 h 54.072"
              id="path112" />
           <path
              d="m 289,64.575 -0.814,4.42 c -0.248,0.873 -0.708,1.701 -1.87,2.372 l -2.09,9.601 c 0.618,0.319 1.547,0.909 1.412,1.888 l -0.064,0.352 h -78.75 l 7.966,-20.34 19.674,1.707 H 289 M 115.168,4.551 c 6.939,4.525 22.344,18.215 27.198,25.606 27.534,-1.134 57.954,7.776 61.975,13.645 l -3.513,11.176 4.659,6.313 c 1.883,2.872 1.365,5.373 0.906,6.858 l -4.919,14.501 -0.214,1.531 2.202,3.65 h -19.156 c -1.517,-0.162 -2.335,-0.979 -2.444,-2.46 v -9.089 c 0,-15.449 -8.267,-27.973 -18.464,-27.973 -10.197,0 -18.102,12.509 -17.811,27.956 0.056,3.01 0.493,6.002 0.842,8.995 -0.077,1.462 -0.788,2.404 -2.444,2.572 H 52.621 c -1.452,-0.181 -2.247,-1 -2.38,-2.46 v -9.089 c 0,-15.449 -8.267,-27.973 -18.464,-27.973 -9.428,0 -16.598,7.841 -17.59,25.612 -0.081,1.449 0.103,3.805 0.103,5.375 -0.212,1.449 -0.953,2.346 -2.444,2.46 L 3.573,78.709 C 1.988,77.916 1.107,76.187 0.985,73.701 L 0.016,58.029 c -0.223,-4.624 1.937,-6.216 2.843,-8.167 0.236,-5.573 2.266,-11.146 2.502,-16.719 0.094,-3.107 2.971,-5.847 5.561,-6.278 4.835,-0.802 9.79,-1.789 10.662,-2.139 8.025,-3.214 5.778,-2.876 14.385,-8.82 C 47.674,7.822 58.011,3.294 66.8,2.16 79.681,0.498 104.026,-2.717 115.168,4.551"
              id="path114" />
         </g>
         <path
            d="m 146.491,83.208 0.317,2.328 c -0.078,1.304 -0.795,2.145 -2.464,2.295 H 52.258 c -1.464,-0.162 -2.265,-0.893 -2.399,-2.195 v -2.428 h 96.631"
            class="H"
            id="path118" />
         <path
            fill="#c81717"
            d="m 3.693,45.302 c 0.641,-3.389 1.534,-6.778 1.886,-10.17 h 2.888 c 2.115,0 3.184,1.849 2.303,3.253 l -2.474,4.277 c -0.71,1.471 -2.062,2.452 -4.35,2.639 H 3.694"
            id="path120" />
         <path
            d="m 185.588,87.83 h -1.241 c -1.526,-0.16 -2.349,-0.969 -2.459,-2.434 V 76.4 c 0,-15.29 -8.316,-27.684 -18.573,-27.684 -10.257,0 -18.209,12.379 -17.916,27.667 0.056,2.979 0.496,5.94 0.847,8.902 -0.078,1.447 -0.793,2.379 -2.459,2.545 h -2.519 V 76.633 c 0,-18.324 9.923,-33.18 22.159,-33.18 12.236,0 22.161,14.856 22.161,33.18 V 87.83 m -131.112,0 H 52.722 C 51.261,87.651 50.461,86.84 50.328,85.396 V 76.4 c 0,-15.29 -8.316,-27.684 -18.574,-27.684 -9.484,0 -16.697,7.76 -17.695,25.348 -0.082,1.434 0.103,3.766 0.103,5.319 -0.213,1.434 -0.959,2.321 -2.459,2.434 l -1.547,-0.561 v -4.624 c 0,-9.17 1.582,-17.92 5.599,-23.924 4.008,-5.993 10.447,-9.256 16.561,-9.256 12.238,0 22.16,14.856 22.16,33.18 V 87.83"
            class="H"
            id="path122" />
         <path
            fill="#2e333d"
            d="m 171.52,1.849 c 17.369,3.652 32.494,11.65 46.384,22.729 l -51.229,0.692 -21.371,1.541 c -4.18,-5.41 -9.433,-10.826 -14.474,-15.378 -3.278,-2.964 -7.218,-6.195 -10.799,-8.79 l 51.488,-0.794"
            id="path124" />
         <path
            d="m 211.441,25.594 -44.807,0.604 -21.37,1.538 c -4.09,-5.284 -9.21,-10.575 -14.152,-15.059 5.096,-0.431 10.355,-0.658 15.734,-0.658 26.077,0 49.345,5.293 64.595,13.575"
            class="D"
            id="path126" />
         <path
            d="m 227.428,45.95 c 0.553,0.047 0.832,0.65 0.674,1.099 l -0.657,2.293 c -0.223,0.669 -0.737,0.897 -1.233,0.859 l -6.28,-0.434 c -0.635,-0.053 -1.151,-0.261 -1.534,-0.635 l -3.025,-2.822 c -0.537,-0.472 -0.128,-1.339 0.57,-1.267 z m -20.213,-1.647 -9.63,-0.822 c -1.101,-0.115 -1.981,0.125 -2.603,0.771 l -1.679,1.936 c -0.483,0.536 -0.407,1.279 0.05,1.69 l 6.899,6.208 c 0.635,0.553 1.445,0.846 2.381,0.956 l 27.531,2.276 c 0.583,0.06 0.895,-0.723 0.466,-1.211 l -2.013,-2.081 c -0.362,-0.404 -0.858,-0.574 -1.521,-0.642 l -9.456,-0.669 -7.818,-7.3 c -0.672,-0.646 -1.539,-1.001 -2.607,-1.111 v 0 z"
            class="B"
            id="path128"
            style="fill:#ffffff" />
         <path
            d="M 104.728,4.529 C 91.476,2.921 75.883,3.764 65.371,6.05 54.513,8.411 47.666,13.073 40.893,17.572 c -1.953,1.295 -3.104,3.853 -3.018,6.171 l -0.019,4.193 c 0.105,1.237 0.658,1.896 1.901,1.922 l 95.893,0.651 c 0.97,0 1.411,-0.869 0.514,-1.815 C 130.875,22.756 124.456,16.429 118.38,11.609 113.155,7.465 109.475,5.32 104.728,4.528"
            class="E"
            id="path130" />
         <path
            d="m 233.606,46.226 c -0.846,0.02 -1.413,0.46 -1.722,1.287 l -0.941,3.346 c -0.25,0.939 -0.084,1.785 0.546,2.522 l 3.491,3.789 a 2.67,2.67 0 0 0 2.201,1.074 h 37.302 c 0.749,-0.024 1.426,-0.55 1.765,-1.364 l 1.295,-3.809 c 0.379,-1.116 0.451,-1.664 0.317,-2.763 l -0.324,-2.675 c -0.068,-0.726 -0.677,-1.408 -1.498,-1.408 h -42.431"
            class="D"
            id="path132" />
         <path
            fill="#141414"
            d="m 233.663,46.226 c -0.864,0.02 -1.442,0.46 -1.758,1.287 l -0.961,3.346 c -0.255,0.939 -0.086,1.785 0.557,2.522 l 3.563,3.789 c 0.615,0.759 1.378,1.074 2.246,1.074 h 35.257 c 0.762,-0.024 1.453,-0.55 1.801,-1.364 l 1.322,-3.809 c 0.386,-1.116 0.458,-1.664 0.321,-2.763 l -0.33,-2.675 c -0.067,-0.726 -0.691,-1.408 -1.529,-1.408 h -40.488"
            id="path134" />
         <g
            class="E"
            id="g140">
           <path
              d="m 284.307,72.179 c 0.289,-1.077 -0.244,-1.915 -1.51,-1.915 l -48.315,0.02 c -1.537,0 -2.584,0.838 -3.034,1.739 l -3.252,6.498 c -0.456,0.911 0.315,1.913 1.208,1.913 h 50.732 c 1.349,-0.012 2.169,-0.604 2.424,-1.575 l 1.747,-6.68"
              id="path136" />
           <path
              d="m 280.023,70.264 h -0.152 l -45.376,0.014 c -1.54,0 -2.589,0.838 -3.04,1.74 l -3.259,6.502 c -0.457,0.912 0.315,1.914 1.21,1.914 h 47.974 c 1.353,-0.012 2.175,-0.604 2.43,-1.576 l 1.727,-6.68 c 0.287,-1.076 -0.247,-1.914 -1.514,-1.914 m -58.587,1.973 c 0.457,-0.896 -0.089,-1.787 -1.228,-1.878 L 207.411,69.34 c -1.44,-0.002 -2.497,0.606 -3.071,1.728 l -3.814,7.461 c -0.498,0.975 0.188,1.893 1.219,1.895 l 13.308,0.01 c 1.369,-0.012 2.497,-0.604 2.993,-1.57 l 3.389,-6.626"
              id="path138" />
         </g>
         <path
            fill="#2e333d"
            d="m 51.526,28.093 a 0.89,0.89 0 0 1 0.013,-0.183 l 2.05,-9.168 2.671,-8.614 c -4.353,1.969 -8.313,4.22 -11.922,6.72 -1.157,3.676 -1.696,7.414 -1.864,11.189 l 9.053,0.058 z m 23.965,0.164 -22.169,-0.151 c 0.522,-2.952 1.195,-5.933 1.995,-8.904 C 56.153,16.099 57.13,13 58.218,9.955 58.261,9.838 58.346,9.569 58.447,9.23 60.803,8.326 63.315,7.566 66.104,6.96 70.857,5.924 76.123,5.244 81.503,4.897 78.36,12.258 76.442,20.043 75.518,27.899 75.501,28.018 75.49,28.138 75.49,28.257 Z M 104.747,5.462 c 5.095,0.861 8.954,3.617 12.925,6.773 6.079,4.829 11.916,10.601 17.133,16.425 L 82.6,28.304 c 0.008,-0.032 0.015,-0.066 0.019,-0.098 0.517,-8.292 1.826,-15.059 4.379,-22.497 0.064,-0.17 0.203,-0.573 0.355,-1.059 6.017,-0.121 11.997,0.158 17.394,0.812 z"
            id="path142" />
         <path
            d="m 207.185,69.34 c -1.318,0.041 -2.438,0.647 -2.972,1.729 l -3.691,7.462 c -0.482,0.975 0.182,1.893 1.18,1.895 l 9.667,0.008 c 1.281,-0.039 2.331,-0.624 2.798,-1.569 l 3.576,-6.846 c 0.444,-0.896 -0.057,-1.893 -1.188,-1.879 l -9.37,-0.801"
            class="E"
            id="path146" />
         <path
            fill="#121212"
            d="m 172.223,2.832 c 16.753,3.801 32.124,11.103 45.575,21.71 l -50.674,0.595 -21.082,1.54 C 141.861,21.395 136.773,16.362 131.729,11.917 128.45,9.023 125.007,6.234 121.424,3.7 l 50.798,-0.869 z m -2.451,-0.983 -49.934,0.858 c -0.746,0 -1.003,0.449 -0.377,0.877 9.421,6.422 20.015,16.341 26.106,24.151 l 21.601,-1.579 52.581,-0.617 C 207.599,15.591 191.184,6.221 169.77,1.847 v 0 z"
            id="path148" />
         <path
            fill="#0b0c0b"
            d="m 52.931,36.981 h -7.066 c -0.85,0 -1.545,0.623 -1.545,1.386 0,0.763 0.695,1.388 1.545,1.388 h 7.066 c 0.85,0 1.545,-0.625 1.545,-1.388 0,-0.763 -0.695,-1.386 -1.545,-1.386 m 40.626,0 h -7.066 c -0.85,0 -1.545,0.623 -1.545,1.386 0,0.763 0.695,1.388 1.545,1.388 h 7.066 c 0.85,0 1.545,-0.625 1.545,-1.388 0,-0.763 -0.695,-1.386 -1.545,-1.386"
            id="path150" />
         <path
            fill="#050505"
            d="m 261.602,50.849 h -7.066 c -0.85,0 -1.545,0.624 -1.545,1.387 0,0.763 0.695,1.387 1.545,1.387 h 7.066 c 0.85,0 1.545,-0.624 1.545,-1.387 0,-0.763 -0.695,-1.387 -1.545,-1.387"
            id="path152" />
         <path
            fill="#b2b2b2"
            d="m 263.446,50.849 h -7.064 c -0.85,0 -1.545,0.624 -1.545,1.387 0,0.763 0.695,1.387 1.545,1.387 h 7.064 c 0.85,0 1.547,-0.624 1.547,-1.387 0,-0.763 -0.697,-1.387 -1.547,-1.387"
            id="path154" />
         <g
            fill="#186fd6"
            id="g160">
           <path
              d="m 132.949,31.102 c 2.393,1.318 5.13,-1.558 2.845,-3.853 l -7.363,-7.383 c -2.272,-2.125 -7.327,3.835 -5.055,5.96 l 9.573,5.276"
              id="path156" />
           <path
              d="m 115.647,19.435 9.627,-0.924 c 5.784,-0.558 6.862,10.645 1.072,10.133 l -9.817,-0.871 c -5.791,-0.511 -6.668,-7.78 -0.882,-8.338"
              id="path158" />
         </g>
         <path
            d="m 124.435,20.357 -6.767,0.743 c -1.959,0.214 -1.661,3.07 0.298,3.22 l 8.324,0.639 c 1.961,0.15 1.384,-4.957 -1.854,-4.602 m 92.729,51.533 c 1.244,0.066 0.805,1.898 -0.456,1.831 l -14.156,-0.745 c -0.454,0 0.262,-1.788 0.874,-1.788 z m -16.692,5.347 c -0.384,-0.101 0.31,-1.811 0.883,-1.811 l 13.845,0.391 c 1.244,0.041 0.807,1.883 -0.456,1.842 z m 80.314,-5.124 c 1.245,0 1.019,1.804 -0.239,1.804 h -50.436 c -0.48,0 0.307,-1.804 0.904,-1.804 h 49.77 z m -52.553,5.547 c -0.518,0 0.235,-1.802 0.906,-1.802 h 50.664 c 1.245,0 1.019,1.802 -0.239,1.802 z"
            class="H"
            id="path162"
            style="fill:#e4e4e4;fill-opacity:1" />
         <path
            d="m 280.497,45.907 2.027,-0.605 c 1.506,1.362 0.889,4.47 0.074,4.637 l -1.392,0.23 c -0.521,0.088 -0.87,-0.118 -0.963,-0.794 l -0.277,-2.312 c -0.067,-0.453 0.016,-1.053 0.531,-1.156 z m 2.169,10.812 -2.879,0.571 c -0.819,0.197 -1.071,-0.594 -0.887,-1.087 l 0.789,-2.126 c 0.151,-0.408 0.431,-0.738 0.789,-0.826 l 2.155,-0.637 c 1.045,0.365 1.145,3.831 0.033,4.105 z"
            class="B"
            id="path164"
            style="fill:#ffffff" />
         <path
            fill="#212121"
            d="m 148.802,43.453 h -3.325 c -0.838,0 -2.017,0.63 -2.62,1.4 l -2.159,2.748 c -0.603,0.77 -0.414,1.4 0.424,1.4 h 3.325 c 0.838,0 2.017,-0.63 2.62,-1.4 l 2.159,-2.748 c 0.603,-0.77 0.412,-1.4 -0.424,-1.4"
            id="path166" />
       </g>
     </g>
   </g>
   <g
      inkscape:groupmode="layer"
      id="layer4"
      inkscape:label="Capa 4">
     <g
        transform="matrix(0.53685504,0.20357033,-0.19539909,0.55930532,150.8422,34.464468)"
        id="g174"
        style="display:inline">
       <path
          fill="#0fb799"
          d="m 27.767,57.552 c -1.327,1.131 -3.319,0.972 -4.449,-0.355 -0.178,-0.208 -0.327,-0.439 -0.445,-0.686 -1.02,-2.134 -3.439,-3.21 -5.707,-2.541 -1.672,0.493 -3.427,-0.462 -3.92,-2.134 -0.077,-0.262 -0.12,-0.534 -0.128,-0.807 C 13.054,48.665 11.282,46.697 8.938,46.386 7.21,46.157 5.995,44.57 6.224,42.842 6.26,42.571 6.331,42.305 6.436,42.052 7.339,39.866 6.521,37.348 4.505,36.11 3.02,35.198 2.555,33.254 3.468,31.769 c 0.143,-0.233 0.316,-0.447 0.514,-0.635 1.714,-1.63 1.991,-4.263 0.653,-6.213 -0.986,-1.438 -0.62,-3.402 0.818,-4.388 0.226,-0.155 0.471,-0.28 0.728,-0.371 2.229,-0.792 3.552,-3.085 3.124,-5.41 -0.316,-1.714 0.818,-3.36 2.532,-3.676 0.269,-0.05 0.544,-0.064 0.816,-0.043 2.358,0.183 4.5,-1.373 5.054,-3.672 0.409,-1.694 2.114,-2.737 3.808,-2.328 0.266,0.064 0.523,0.163 0.763,0.293 2.08,1.126 4.669,0.576 6.111,-1.299 1.063,-1.382 3.044,-1.641 4.426,-0.578 0.217,0.167 0.411,0.361 0.578,0.578 1.442,1.875 4.031,2.425 6.111,1.299 1.533,-0.83 3.448,-0.261 4.278,1.272 0.13,0.241 0.229,0.497 0.293,0.763 0.554,2.299 2.696,3.855 5.054,3.672 1.738,-0.135 3.256,1.164 3.391,2.902 0.021,0.273 0.007,0.547 -0.043,0.816 -0.429,2.326 0.895,4.619 3.124,5.41 1.642,0.584 2.501,2.388 1.917,4.031 -0.092,0.258 -0.216,0.503 -0.371,0.728 -1.338,1.95 -1.061,4.584 0.653,6.213 1.263,1.201 1.313,3.199 0.112,4.462 -0.189,0.198 -0.402,0.371 -0.635,0.514 -2.015,1.238 -2.833,3.756 -1.931,5.942 0.665,1.611 -0.101,3.457 -1.712,4.122 -0.253,0.104 -0.518,0.176 -0.79,0.212 -2.344,0.311 -4.116,2.279 -4.18,4.643 -0.047,1.742 -1.498,3.117 -3.241,3.069 -0.274,-0.007 -0.545,-0.05 -0.807,-0.128 -2.268,-0.669 -4.687,0.407 -5.707,2.541 -0.752,1.573 -2.636,2.238 -4.209,1.486 -0.247,-0.118 -0.477,-0.268 -0.686,-0.445 -1.8,-1.534 -4.448,-1.534 -6.247,0 z"
          id="path170"
          style="fill:#ff9400;fill-opacity:1" />
       <path
          d="m 23.331,32.272 a 5.33,5.33 0 0 0 3.873,-1.593 c 1.081,-1.062 1.621,-2.339 1.621,-3.83 a 5.15,5.15 0 0 0 -1.621,-3.823 5.34,5.34 0 0 0 -3.873,-1.586 5.32,5.32 0 0 0 -3.866,1.586 c -1.076,1.057 -1.614,2.332 -1.614,3.823 0,1.491 0.538,2.771 1.614,3.837 a 5.32,5.32 0 0 0 3.866,1.586 z M 25.54,43.473 37.321,22.006 H 34.206 L 22.439,43.472 H 25.54 Z M 23.331,29.115 c -0.623,0 -1.145,-0.222 -1.565,-0.666 -0.42,-0.444 -0.63,-0.977 -0.63,-1.6 a 2.16,2.16 0 0 1 0.623,-1.572 2.11,2.11 0 0 1 1.572,-0.651 c 0.623,0 1.147,0.215 1.572,0.644 0.425,0.429 0.637,0.956 0.637,1.579 a 2.23,2.23 0 0 1 -0.637,1.6 2.09,2.09 0 0 1 -1.572,0.666 z m 12.914,14.769 c 1.501,0 2.79,-0.531 3.866,-1.593 1.076,-1.062 1.614,-2.339 1.614,-3.83 0,-1.491 -0.538,-2.768 -1.614,-3.83 -1.076,-1.062 -2.365,-1.593 -3.866,-1.593 -1.501,0 -2.79,0.531 -3.866,1.593 -1.076,1.062 -1.614,2.339 -1.614,3.83 0,1.491 0.538,2.771 1.614,3.837 a 5.32,5.32 0 0 0 3.866,1.586 z m 0,-3.172 a 2.1,2.1 0 0 1 -1.572,-0.658 c -0.425,-0.439 -0.637,-0.97 -0.637,-1.593 0,-0.623 0.212,-1.152 0.637,-1.586 a 2.11,2.11 0 0 1 1.572,-0.651 c 0.623,0 1.145,0.217 1.565,0.651 0.42,0.434 0.63,0.963 0.63,1.586 a 2.22,2.22 0 0 1 -0.63,1.593 c -0.42,0.439 -0.942,0.658 -1.565,0.658 z"
          class="B F"
          id="path172"
          style="fill:#ececec" />
     </g>
   </g>
 </svg>`,
    // alt: 'cotizador_svg',
    textFloat: "right",
    alt: 'cotizador_img',
}
